<template>
  <div class="new_mob_menu  animatedlong slideInRight" v-show="mobMenuVisible && winW < 1024">
      <div class="nmm_header">
      </div>
      <div class="nmm_content">
        <!-- <div class="nmm_current_cinema">
          Киев, SkyMall
          <img src="/img/arrow_down.svg" class="arrow">
        </div> -->
  
        <div class="nmm_menu_list">
          <p>
            <a href="javascript:;" class="menu_item ">
              {{ $t("pop_ups.left_menu.now_in_cinema") }}</a>
          </p>
          <p></p>
          <p>
            <a href="/soon" class="menu_item">
              {{ $t("pop_ups.left_menu.soon") }}</a>
          </p>
          <p>
            <a href="/promotions" class="menu_item">
              {{ $t("pop_ups.left_menu.promos") }}</a>
          </p>
          <p>
            <a href="/cinemas" class="menu_item">
              {{ $t("pop_ups.left_menu.cinemas") }}</a>
          </p>
          <p>
            <a href="/faq" class="menu_item">
              {{ $t("pop_ups.left_menu.faq") }}</a>
          </p>
          <p>
            <a href="/about" class="menu_item">
              {{ $t("pop_ups.left_menu.about") }}</a>
          </p>
          <p>
            <a href="/about" class="menu_item active">
              {{ $t("pop_ups.left_menu.personal") }}</a>
          </p>
          <p>
            <a href="https://auth.multiplex.ua/logout" class="menu_item">
              {{ $t("pop_ups.left_menu.logout") }}</a>
          </p>
        </div>
        <ul class="nmm_lang_sw">
          <li data-lang="ru" :class="{'active': $i18n.locale === 'ru'}">
            <a href="#" hreflang="ru" @click="setLang('ru')">ru</a>
          </li>
          <li data-lang="ua" :class="{'active': $i18n.locale === 'ua'}">
            <a href="#" hreflang="uk" @click="setLang('ua')">ua</a>
          </li>
        </ul>
      </div>
    </div>
</template>
<script>
import Store from '../../store'
export default {
  computed: {
    winW: function () {
      return Store.state.winW
    },
    mobMenuVisible: function () {
      return Store.state.mobMenuVisible
    }
  },
  methods: {
    setLang: function (lang) {
      Store.commit('setLang', lang)
      this.$i18n.locale = lang
      this.$cookie.set('uLang', lang, {expires: 365, domain: '.multiplex.ua'})
      this.hideMobMenu()
      document.title = this.$t('commons.title')
    },
    hideMobMenu: function () {
      Store.commit('hideMobMenu')
    }
  }
}
</script>



// WEBPACK FOOTER //
// mob-menu.vue?fd576ada